import {Box, Select, Stack, TextField} from '@wellstone-solutions/web';
import {halfWidthSx} from '../NoteForm';
import type {Choice} from '../types';
import {OTHER, toSelectItems} from '../types';

type ContactMethodSectionProps<K extends string> = {
  options: readonly Choice<K>[];
  value: K | null;
  onChange: (key: K) => void;
  detail: string;
  onDetailChange: (text: string) => void;
};

export const ContactMethodSection = <K extends string>({
  options,
  value,
  onChange,
  detail,
  onDetailChange,
}: ContactMethodSectionProps<K>) => (
  <Stack direction={{xs: 'column', md: 'row'}} spacing={2}>
    <Box sx={halfWidthSx}>
      <Select
        label="How did you contact the member?"
        items={toSelectItems(options)}
        value={value ?? ''}
        canUnselect={false}
        containerProps={{required: true, fullWidth: true}}
        onChange={(event) => onChange(event.target.value as K)}
      />
    </Box>
    <TextField
      required={value === OTHER}
      label="Contact method details"
      placeholder="Please specify"
      value={detail}
      onChange={(event) => onDetailChange(event.target.value)}
      sx={{flex: 1}}
    />
  </Stack>
);
